var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"prefix":_vm.prefix,"hide-details":_vm.hideDetails,"rules":_vm.getRules(),"solo":""},on:{"change":_vm.formatCurrencyInput},model:{value:(_vm.currencyString),callback:function ($$v) {_vm.currencyString=$$v},expression:"currencyString"}})
}
var staticRenderFns = []

export { render, staticRenderFns }